import { Instance, SnapshotIn, types } from 'mobx-state-tree';

const CgRegion = types.model('CgRegion', {
	id: types.maybe(types.number),
	name_en: types.string,
	name_uk: types.string,
});

export default CgRegion;

export interface ICgRegionModel extends Instance<typeof CgRegion> {}
export type ICgRegionSnapshotIn = SnapshotIn<typeof CgRegion>;
